import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const mimeTypes = {
    'gif': 'image/gif',
    'png': 'image/png',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
}

const hostname = (typeof window !== 'undefined') ?
    `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}` :
    process.env.WEBSITE_HOSTNAME;

const InnerHelmet = (props) => {
    let ogTitle = props.ogTitle || props.title; // allow using props.ogTitle override og:title
    let title = props.title ? `${props.title} | Studio TM` : 'Studio TM';
    let description = props.description || 'Studio TM is an Award-winning creative studio in Hong Kong founded in 2010 by two creative talents Topaz Leung and Martin Cheung, focusing photography, advertising, art direction and art education.';
    let image = props.image ? {...props.image} : { // do a clone as we may modify .src
        src: '/og-image.png',
        width: 1200,
        height: 627,
    };
    let mimeType = mimeTypes[image.src.split('.').pop()] || '';

    // prefix og:image if it is not full path
    if(!image.src.match(/^https?:/)){
        image.src = hostname + image.src;
    }

    // description only takes first sentence
    description = description.split('\n')[0];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:url" content={hostname + props.location.pathname} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={ogTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:locale" content="en_HK" />
            <meta property="og:site_name" content="Studio TM" />
            <meta property="og:image" content={image.src} />
            <meta property="og:image:type" content={mimeType} />
            <meta property="og:image:width" content={image.width} />
            <meta property="og:image:height" content={image.height} />
        </Helmet>
    )
}

const MyHelmet = (props) => {
    return <Route render={(renderProps) =>
        <InnerHelmet location={renderProps.location} {...props} />}
    />
}

MyHelmet.propsType = {
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.object,
}

export default MyHelmet;



// WEBPACK FOOTER //
// ./src/components/common/MyHelmet.jsx